/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateStudentProfile } from '../../models/create-student-profile';
import { StudentProfile } from '../../models/student-profile';

export interface CreateStudentProfile$Params {
      body?: CreateStudentProfile
}

export function createStudentProfile(http: HttpClient, rootUrl: string, params?: CreateStudentProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
  const rb = new RequestBuilder(rootUrl, createStudentProfile.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfile>;
    })
  );
}

createStudentProfile.PATH = '/studentprofile';
